import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class MobileContactsService {
  isOpen = signal(false);
  isOpen$ = toObservable(this.isOpen);

  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  toggle(): void {
    return this.isOpen() ? this.close() : this.open();
  }

  open(): void {
    if (this.isOpen()) {
      return;
    }
    this.renderer.addClass(this.document.body, 'sd-swipeable-panel--opened');
    this.isOpen.set(true);
  }

  close(): void {
    if (!this.isOpen()) {
      return;
    }
    this.renderer.removeClass(this.document.body, 'sd-swipeable-panel--opened');
    this.isOpen.set(false);
  }
}
